"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const zod_1 = require("zod");
const SearchContextProvider_1 = require("../../../../../shared/contexts/SearchContextProvider");
const http_requests_1 = require("../../../../../shared/http-requests");
const CodEmpresaConst = __importStar(require("../../../../../shared/const/CodEmpresaConst"));
const helpers_1 = require("../../../../../shared/helpers");
const Button_1 = __importDefault(require("../../../../consulta-acessibilidade/Button"));
const AccessibilityContext_1 = require("../../../../consulta-acessibilidade/contexts/AccessibilityContext");
const react_hook_form_1 = require("react-hook-form");
const zod_2 = require("@hookform/resolvers/zod");
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const RepositorySelector_1 = __importDefault(require("../../Home/v2/RepositorySelector"));
const AppInfo_1 = __importDefault(require("../../../../../shared/components/AppInfo"));
const AppContextProvider_1 = require("../../../../../shared/contexts/AppContextProvider");
const pesquisa_1 = require("../../../../../store/ducks/pesquisa");
const GlobalEvent_1 = __importDefault(require("../../../../../shared/events/GlobalEvent"));
const AppSearchInput_1 = __importDefault(require("../../../../../shared/components/AppSearchInput"));
const hooks_1 = require("../../../../../shared/hooks");
const schema = zod_1.z.object({
    searchTerm: zod_1.z.string().min(1, 'CampoBuscaObrigatorio'),
    searchOption: zod_1.z
        .string()
        .min(1, 'É necessario informar a opção de pesquisa.'),
});
const GeneralSearch = ({ instituicaoRx, guiasPesquisaRx, onChangeSearch, autoCompleteTerms }) => {
    var _a, _b;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [searchOptions, setSearchOptions] = (0, react_1.useState)(undefined);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { searchInputRef } = (0, AccessibilityContext_1.useAccessibilityContext)();
    const { search, loadingSearch, lastSearchForm, researchDone } = (0, SearchContextProvider_1.useSearchContext)();
    const { selectedTab, lang } = (0, AppContextProvider_1.useAppContext)();
    const [lastSearchOptionValue, setLastSearchOptionValue] = (0, react_1.useState)();
    const location = (0, react_router_dom_1.useLocation)();
    const [repBases, setRepBases] = (0, react_1.useState)();
    const searchParams = new URLSearchParams(location.search);
    const { rep, changeRep } = (0, SearchContextProvider_1.useSearchContext)();
    const { clearFilters } = (0, hooks_1.usePesquisaPaginadaParams)();
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue } = (0, react_hook_form_1.useForm)({
        resolver: (0, zod_2.zodResolver)(schema),
        defaultValues: {
            searchOption: (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.coluna_um) || searchParams.get('for') || 'LIVRE',
            searchTerm: (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.termo_pesquisa) || searchParams.get('q') || '',
        },
    });
    const data = watch();
    const searchTerm = watch('searchTerm');
    (0, react_1.useEffect)(() => {
        if (onChangeSearch) {
            onChangeSearch(data);
        }
    }, [data.searchOption, data.searchTerm]);
    (0, react_1.useEffect)(() => {
        reset({
            searchOption: (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.coluna_um) || searchParams.get('for') || 'LIVRE',
            searchTerm: (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.termo_pesquisa) || searchParams.get('q') || '',
        });
    }, [lastSearchForm, reset, searchOptions]);
    /**
     * Opções de repositorios de base
     */
    const repOptions = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return [
            {
                permission: 89,
                label: ((_a = helpers_1.Permissao.busca(89)) === null || _a === void 0 ? void 0 : _a.descricao)
                    ? (_b = helpers_1.Permissao.busca(89)) === null || _b === void 0 ? void 0 : _b.descricao
                    : 'Rede Pergamum',
                value: 'rede_pergamum',
            },
            {
                permission: 118,
                label: ((_c = helpers_1.Permissao.busca(118)) === null || _c === void 0 ? void 0 : _c.descricao)
                    ? (_d = helpers_1.Permissao.busca(118)) === null || _d === void 0 ? void 0 : _d.descricao
                    : 'ABNT',
                value: 'abnt',
            },
            {
                permission: 113,
                label: ((_e = helpers_1.Permissao.busca(113)) === null || _e === void 0 ? void 0 : _e.descricao)
                    ? (_f = helpers_1.Permissao.busca(113)) === null || _f === void 0 ? void 0 : _f.descricao
                    : 'Pesquisa Target Gedweb',
                value: 'target_gedweb',
            },
            {
                permission: 108,
                label: ((_g = helpers_1.Permissao.busca(108)) === null || _g === void 0 ? void 0 : _g.descricao)
                    ? (_h = helpers_1.Permissao.busca(108)) === null || _h === void 0 ? void 0 : _h.descricao
                    : 'Rede Pergamum OAI',
                value: 'rede_pergamum_oai',
            },
            {
                permission: 109,
                label: ((_j = helpers_1.Permissao.busca(109)) === null || _j === void 0 ? void 0 : _j.descricao)
                    ? (_k = helpers_1.Permissao.busca(109)) === null || _k === void 0 ? void 0 : _k.descricao
                    : 'Rede OAI Local',
                value: 'rede_oai_local',
            },
            {
                permission: 96,
                label: ((_l = helpers_1.Permissao.busca(96)) === null || _l === void 0 ? void 0 : _l.descricao)
                    ? (_m = helpers_1.Permissao.busca(96)) === null || _m === void 0 ? void 0 : _m.descricao
                    : 'Rede Ebsco',
                value: 'rede_ebsco',
            },
        ].filter(({ permission }) => helpers_1.Permissao.tem(permission));
    }, []);
    (0, react_1.useEffect)(() => {
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        const { token } = cancelTokenSrc;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const data = yield fetchSearchOptions(token);
            if (data) {
                let optionsAux = [
                    { label: t('LIVRE'), value: 'LIVRE', grupo: '0' },
                    {
                        label: `${t('TITULO')} ${t('PalavraQualquerPosicao')}`,
                        value: 'TITULO',
                        grupo: '1',
                    },
                    {
                        label: `${t('AUTOR')} ${t('PalavraQualquerPosicao')}`,
                        value: 'AUTOR',
                        grupo: '2',
                    },
                    {
                        label: `${t('ASSUNTO')} ${t('PalavraQualquerPosicao')}`,
                        value: 'ASSUNTO',
                        grupo: '3',
                    },
                ];
                if ((instituicaoRx === null || instituicaoRx === void 0 ? void 0 : instituicaoRx.codEmpresa) === CodEmpresaConst.CJF) {
                    optionsAux = optionsAux.concat([
                        {
                            label: t('LIVRE_SIMILAR'),
                            value: 'LIVRE_SIMILAR',
                            grupo: '0',
                        },
                        {
                            label: t('TITULO_SIMILAR'),
                            value: 'TITULO_SIMILAR',
                            grupo: '1',
                        },
                        {
                            label: t('AUTOR_SIMILAR'),
                            value: 'AUTOR_SIMILAR',
                            grupo: '2',
                        },
                        {
                            label: t('ASSUNTO_SIMILAR'),
                            value: 'ASSUNTO_SIMILAR',
                            grupo: '3',
                        },
                    ]);
                }
                optionsAux = optionsAux.concat(data);
                const groups = Array.from(helpers_1.ArrayHelper.groupByProperty('grupo', optionsAux).values());
                optionsAux = groups
                    .map((x, i) => i !== groups.length - 1
                    ? x.concat({ label: '-------', value: 'sep' })
                    : x)
                    .flat();
                setSearchOptions(optionsAux);
            }
        }))();
        return () => {
            cancelTokenSrc.cancel();
        };
    }, [lang]);
    const fetchSearchOptions = (cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield http_requests_1.ConsultaAPI.buscarOpcoesConsultaIndice(cancelToken);
            const { data } = response;
            if (data) {
                data.forEach(item => {
                    i18next_1.default.addResource('pt', 'translation', item.value, item.label);
                    i18next_1.default.addResource('en', 'translation', item.value, item.label);
                    i18next_1.default.addResource('es', 'translation', item.value, item.label);
                });
            }
            return data;
        }
        catch (error) {
            if (!axios_1.default.isCancel(error))
                console.log('error on request service data: ', error);
        }
        return null;
    });
    const handleSearch = (data) => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            let form = {
                termo_pesquisa: data.searchTerm,
            };
            //limpando filtros para que não haja erro na alteração do combo de indices.
            clearFilters();
            form.coluna_um = `${data.searchOption}${repBases !== undefined ? `,${repBases}` : ''}`;
            let urlParams = { for: data.searchOption, q: data.searchTerm };
            if (rep) {
                form.base = rep;
                urlParams.rep = rep;
                if (repBases !== undefined) {
                    urlParams.repBases = repBases;
                }
            }
            if (guiasPesquisaRx.length) {
                const isPesquisaPaginada = !!guiasPesquisaRx.find(guia => guia.codigo === selectedTab &&
                    guia.usa_consulta_paginada);
                if (isPesquisaPaginada) {
                    const newParams = {
                        page: 1,
                        perPage: 20,
                        // orderBy:
                        //     process.env.REACT_APP_CONSULTA_PAGINADA_ORDENACAO,
                        // direction: 'C',
                    };
                    dispatch((0, pesquisa_1.changeSearch)(false));
                    urlParams = Object.assign(Object.assign({}, urlParams), newParams);
                    form = Object.assign(Object.assign({}, form), newParams);
                }
            }
            yield search(form, urlParams);
        }))();
    };
    const formRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const handleClearSearch = () => {
            reset({
                searchOption: 'LIVRE',
                searchTerm: ''
            });
        };
        GlobalEvent_1.default.on("CLEAR_SEARCH", handleClearSearch);
        // Cleanup: Remover o evento ao desmontar o componente
        return () => {
            GlobalEvent_1.default.off("CLEAR_SEARCH", handleClearSearch);
        };
    }, [reset]);
    return (react_1.default.createElement(react_bootstrap_1.Form, { ref: formRef, onSubmit: handleSubmit(handleSearch) },
        react_1.default.createElement(react_bootstrap_1.Row, { className: "content__left__input p-3" },
            react_1.default.createElement(react_bootstrap_1.Col, { md: 11, sm: "12", className: "input-holder mt-3 mt-md-3 m-auto" },
                react_1.default.createElement("div", { className: "rotulo" }, t('CampoBusca')),
                react_1.default.createElement(react_bootstrap_1.Row, { className: 'm-0 p-0' },
                    react_1.default.createElement(react_bootstrap_1.Col, { className: 'm-0 p-0', xs: '10', md: '11' },
                        react_1.default.createElement(AppSearchInput_1.default
                        //@ts-ignore
                        , { 
                            //@ts-ignore
                            ref: searchInputRef, onEnter: () => {
                                handleSubmit(handleSearch)();
                            }, placeholder: t('DigiteSuaBuscaAqui'), onChange: (value) => {
                                setValue('searchTerm', value);
                            }, value: searchTerm, autoCompleteData: autoCompleteTerms ? autoCompleteTerms.map((x, i) => ({ key: `${x.word}-${i}`, value: x.word })) : [] })),
                    react_1.default.createElement(react_bootstrap_1.Col, { className: 'd-flex justify-content-start align-items-center', xs: '2', md: '1' },
                        react_1.default.createElement(AppInfo_1.default, { message: t('MsgHelpIcon') }))),
                errors.searchTerm ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_a = errors.searchTerm) === null || _a === void 0 ? void 0 : _a.message))) : ('')),
            react_1.default.createElement("div", { className: "col-md-11 m-auto px-0" },
                react_1.default.createElement("div", { className: "row px-0" },
                    react_1.default.createElement(react_bootstrap_1.Col, { lg: "2", md: "3", sm: "12", className: "input-holder mt-3" },
                        react_1.default.createElement("div", { className: "rotulo" }, t('PesquisarPor')),
                        react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ as: "select", className: "b-tema20 cortxt rad10 s14" }, register('searchOption')), searchOptions
                            ? searchOptions.map((item, index) => item.value === 'sep' ? (react_1.default.createElement("option", { disabled: true, key: `termo-${item.value}${index}` }, item.label)) : (react_1.default.createElement("option", { key: `termo-${item.value}`, value: item.value }, item.label)))
                            : '')),
                    (repOptions === null || repOptions === void 0 ? void 0 : repOptions.length) > 0 ? (react_1.default.createElement(react_bootstrap_1.Col, { sm: 12, md: 3, lg: 2, className: "input-holder mt-3" },
                        react_1.default.createElement("div", { className: "rotulo" }, t('TipoBase')),
                        react_1.default.createElement(RepositorySelector_1.default, { value: (_b = searchParams.get('rep')) !== null && _b !== void 0 ? _b : undefined, selectedTab: "pesquisa_geral", repOptions: repOptions, onSelect: (value, aux) => {
                                console.log(`selected: ${value} ${aux}`);
                                setRepBases(aux);
                                changeRep(value === 'local'
                                    ? null
                                    : value);
                            } }))) : null,
                    react_1.default.createElement(react_bootstrap_1.Col, { md: "2", lg: "2", sm: "12", className: (0, classnames_1.default)(' mt-3 px-0 align-self-end') },
                        react_1.default.createElement(Button_1.default, { title: "Pesquisar", icon: "search", variant: "primeiro ml-0 btn_responsivo", type: "submit", disabled: loadingSearch })))))));
};
const mapStateToProps = (state) => ({
    instituicaoRx: state.instituicao.data,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)(GeneralSearch);
